// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-1892ac40],.fade-leave-active[data-v-1892ac40]{transition:opacity .5s}.fade-enter[data-v-1892ac40],.fade-leave-to[data-v-1892ac40]{opacity:0}.selector-wrapper[data-v-1892ac40]{max-width:460px;margin-left:auto;margin-right:auto}@media screen and (min-width:1024px){.selector-wrapper[data-v-1892ac40]{margin-left:unset}}", ""]);
// Exports
module.exports = exports;
